<template>
  <TsColumn dataTestid="column-header" class="is-5 lg:is-2 shrink-0">
  <NuxtLinkWithLocale to="/" @click="handleLogoClickEvent" class="block max-w-max">
    <TsImage
        class="cursor-pointer"
        src="/images/logos/toolstation-logo-halo.svg"
        alt="logo"
        height="44"
        width="179"
        data-testid="header-logo"
    />
  </NuxtLinkWithLocale>
  </TsColumn>


</template>
<script setup lang="ts">
const handleLogoClickEvent = () => {
  logEvent({
    options: {
      eventAction: "click",
      eventProperties: {
        Event:"Cliked"
      },
      eventInteraction: true,
      eventLabel: `Header Logo Clicked`,
      eventName: "header_logo_clicks",
    },
  });
}
</script>